import {gql} from '@apollo/client'

export const GET_PAYMENT = gql`
  query GetPayment($paymentId: ID!) {
    payment(id: $paymentId) {
      id
      description
      amount
      date
      state
      xeroLink
      invoice {
        id
        invoiceNumber
      }
      bankImport {
        name
        createdAt
        organisation {
          id
          internalName
          internalColor
        }
      }
      account {
        id
        displayName @client
        contactFullName @client
        name
        contactFirstName
        contactLastName
      }
      importCode
      importDetails
      importParticulars
      importReference
      reconciledAt
    }
  }
`

export const CREATE_PAYMENT = gql`
  mutation CreateOrUpdatePayment($description: String, $amount: Float, $date: String, $accountId: ID, $state: String) {
    payment(description: $description, amount: $amount, date: $date, accountId: $accountId, state: $state) {
      id
      description
      amount
      date
      state
    }
  }
`

export const UPDATE_PAYMENT = gql`
  mutation CreateOrUpdatePayment(
    $paymentId: ID!
    $description: String
    $amount: Float
    $date: String
    $accountId: ID
    $state: String
  ) {
    payment(
      id: $paymentId
      description: $description
      amount: $amount
      date: $date
      accountId: $accountId
      state: $state
    ) {
      id
      description
      amount
      date
      state
      reconciledAt
    }
  }
`
